import { createSlice } from "@reduxjs/toolkit";
import { UNKNOWN_PAGE } from "./constants";

export const initialState = {
  name: UNKNOWN_PAGE,
  isNewPage: false,
  isServerRendered: true
};

const setPageNameReducer = (state, action) => {
  state.name = action.payload;
};

const setPageLoadingReducer = (state, action) => {
  state.isLoading = action.payload;
};

const setIsNewPageReducer = (state, action) => {
  state.isNewPage = action.payload;
};

const setIsServerRenderedReducer = (state, action) => {
  state.isServerRendered = action.payload;
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    setPageName: setPageNameReducer,
    setPageLoading: setPageLoadingReducer,
    setIsNewPage: setIsNewPageReducer,
    setIsServerRendered: setIsServerRenderedReducer
  }
});

export const {
  setPageName,
  setPageLoading,
  setIsNewPage,
  setIsServerRendered
} = pageSlice.actions;

export default pageSlice.reducer;
